export default "__VITE_ASSET__BuI_I_KI__"